var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20013 15C6.20013 10.1399 10.1403 6.2 15.0007 6.2C19.8611 6.2 23.8012 10.1399 23.8012 15C23.8012 17.5207 22.7413 19.7939 21.0428 21.3983C20.4985 20.0644 19.1834 19.1241 17.6479 19.1241H12.395C10.8486 19.1241 9.52584 20.0777 8.98868 21.4266C7.2726 19.8207 6.20013 17.5356 6.20013 15ZM10.8049 22.7374C12.0521 23.4151 13.4814 23.8 15.0007 23.8C16.5365 23.8 17.9805 23.4066 19.2373 22.715C19.2089 21.8665 18.5085 21.1867 17.6479 21.1867H12.395C11.5268 21.1867 10.8217 21.8784 10.8049 22.7374ZM15.0007 4C8.92517 4 4 8.92487 4 15C4 21.0751 8.92517 26 15.0007 26C21.0762 26 26.0013 21.0751 26.0013 15C26.0013 8.92487 21.0762 4 15.0007 4ZM10.7022 14.2753C10.7022 11.9013 12.6363 9.97736 15.0214 9.97736C17.4065 9.97736 19.3406 11.9013 19.3406 14.2753C19.3406 16.6494 17.4065 18.5733 15.0214 18.5733C12.6363 18.5733 10.7022 16.6494 10.7022 14.2753ZM15.0214 12.04C13.7801 12.04 12.7745 13.0411 12.7745 14.2753C12.7745 15.5096 13.7801 16.5107 15.0214 16.5107C16.2627 16.5107 17.2684 15.5096 17.2684 14.2753C17.2684 13.0411 16.2627 12.04 15.0214 12.04Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.82a976fe0b9e15048a1d8ef7bc6ddb42.svg";
export { ForwardRef as ReactComponent };